import React, { Component } from 'react';
import { Translate } from '$common';



export default class RadioButton extends Component {
  static type = 'radio';
  static optionable = true;
  static elementName = Translate.get('single_choice');
  static icon = 'circle-o';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/radio-button.js